<template>
  <div class="sem-local">
    <!-- 头部banner+表单 -->
    <div class="sem-local-banner">
      <BannerForm
        title="免费试用"
        :logoSrc="logoSrc"
        :pcBgImg="pcBgImg"
        :landingPageName="landingPageName"
        :showForm="!showScrollForm"
        @msg="handleShowMsg"
        @setShowSuccessDialog="setShowSuccessDialog"
        setHeight="540"
      >
        <template slot="title">
          <div class="semlocal-title-content">
            <div class="one-line">集团型企业</div>
            <div class="two-line">统一印章管理应用平台</div>
          </div>
        </template>
        <template slot="desc">
          <div class="semlocal-desc">系统本地部署，隐私数据安全，符合信创要求</div>
        </template>
      </BannerForm>
    </div>
    <!-- banner下方信息 -->
    <div class="banner-bottom">
      <div class="content">
        <div class="item" v-for="(item, index) in bannerBottomData" :key="index">
          <div class="first-line-text">{{ item.firstLineText }}</div>
          <div class="second-line-text">{{ item.secondLineText }}</div>
        </div>
      </div>
    </div>
    <!-- 集团型企业印章管理难点 -->
    <div class="management-difficulties">
      <SectionCard :isPcFlag="true" title="集团型企业印章管理难点" bgColor="#F7F8F9">
        <div class="content">
          <div class="item" v-for="item in difficultyData" :key="item.key">
            <div class="top">
              <div class="left">
                <div class="title">{{ item.title }}</div>
                <div class="line"></div>
              </div>
              <img :src="item.imgSrc" class="right-img" alt="" />
            </div>
            <div class="bottom">
              <div class="desc" v-for="i in item.contentList" :key="i.key">{{ i }}</div>
            </div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 统一印章管理应用平台 -->
    <div class="application-platform">
      <SectionCard :isPcFlag="true" title="统一印章管理应用平台">
        <div class="desc">签章能力中台化，统一向业务端提供用印能力</div>
        <img class="plateform-img" src="@/assets/images/sem-local/platform-img.png" alt="" />
      </SectionCard>
    </div>
    <!-- 实践部署流程 -->
    <div class="deployment-process">
      <SectionCard :isPcFlag="true" title="实践部署流程" :bgImg="flowPathBg">
        <div class="path-content">
          <div class="content">
            <div class="path-left">
              <div class="one-line">
                <div class="item" v-for="item in deployProcessOneLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="one-line-arrow" v-if="item.key !== 4" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
              <div class="two-line">
                <img class="two-line-arrow" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
              </div>
              <div class="three-line">
                <div class="item" v-for="item in deployProcessTwoLine" :key="item.key">
                  <div class="item-content">
                    <img :src="item.imgSrc" alt="" />
                    <p>{{ item.text }}</p>
                  </div>
                  <img class="three-line-arrow" v-if="item.key !== 3" src="@/assets/images/sem-saas/flow-arrow.png" alt="" />
                </div>
              </div>
            </div>
            <div class="path-right">
              <img class="qr-img" src="https://www.esign.cn/upload/resources/image/2024/04/09/43148.png" alt="" />
              <p class="qr-desc">扫码领取成功实践白皮书</p>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- “1+N”本地化系统+签署网络 -->
    <div class="hybrid-cloud">
      <SectionCard :isPcFlag="true" title="“1+N”本地化系统+签署网络">
        <div class="desc-text">更契合中国市场需求的混合云模式</div>
        <div class="content">
          <div class="card" v-for="item in hybridCloudData" :key="item.key">
            <div class="top" :style="{ background: `url(${item.imgSrc}) center center / cover no-repeat` }">
              <div class="introduce">
                <div class="line-text">
                  <div class="one-line-text">{{ item.titleOne }}</div>
                  <div class="two-line-text">{{ item.titleTwo }}</div>
                </div>
                <div class="quotation-mark">”</div>
              </div>
              <div class="desc" :class="item.key === 1 ? 'one' : 'two'">{{ item.desc }}</div>
            </div>
            <div class="bottom">
              <div class="item" :class="{ 'none-dashed': i.key === 5 || i.key === 10 }" v-for="i in item.contentList" :key="i.key">
                <div class="text" :class="{ 'left-two': i.key === 2, 'right-ten': i.key === 10 }">{{ i.text }}</div>
                <div class="symbol">
                  <img v-if="i.status === false" class="error" src="@/assets/images/sem-local/hybrid-cloud-wrong.png" alt="" />
                  <img v-else class="right" src="@/assets/images/sem-local/hybrid-cloud-right.png" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 物电一体统一管理 -->
    <div class="wudian">
      <SectionCard :isPcFlag="true" title="物电一体统一管理" :bgImg="wuDianBg">
        <div class="desc-title">一套系统实现集团<span class="weight">物理章、电子章</span>的双管控</div>
        <div class="content">
          <ul class="tab_title">
            <li v-for="(v, i) in wudianData" :class="m == i ? 'active' : ''" @click="wudian(i)" :key="i.title">{{ v.title }}</li>
          </ul>
          <div class="tab_content">
            <img class="img" v-for="(v, i) in wudianData" v-show="m == i" :key="i" :src="v.imgSrc" alt="" />
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 统一印章信创替代解决方案 -->
    <div class="solution">
      <SectionCard :isPcFlag="true" title="统一印章信创替代解决方案">
        <div class="desc-title">
          e签宝产品已广泛适配信创生态厂商软硬件环境，覆盖操作系统、数据库、中间件、浏览器、密码机、OFD阅读器、Ukey等，快速响应多种技术路线下的信创改造需求
        </div>
        <div class="content">
          <div class="card-item" v-for="item in solutionData" :key="item.key">
            <img class="bg-img" :src="item.imgSrc" alt="" />
            <div class="card-content">
              <div class="title">{{ item.title }}</div>
              <div class="desc" v-for="i in item.textList" :key="i.key">{{ i }}</div>
            </div>
            <div class="rail"></div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- “五统一”构建企业印章管理新模式 -->
    <div class="new-mode">
      <SectionCard :isPcFlag="true" title="“五统一”构建企业印章管理新模式" :bgImg="newModeBg">
        <div class="content">
          <ul class="tab_title">
            <li v-for="(v, i) in newModeData" :class="n == i ? 'active' : ''" @click="n = i" :key="i.title">{{ v.title }}</li>
          </ul>
          <!-- 内容 -->
          <div class="tab_content">
            <div class="content-item" v-for="(v, i) in newModeData" v-show="n == i" :key="i.key">
              <img class="img" :src="v.imgSrc" alt="" />
            </div>
          </div>
        </div>
        <div class="btns-box">
          <div class="btns">
            <div class="mfsy" @click="showDialog">免费试用</div>
            <div class="zxzx" @click="OnlineConsultationClick">在线咨询</div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 实践成功案例 -->
    <div class="success-case">
      <SectionCard
        class="success-case-custom"
        :isPcFlag="true"
        title="实践成功案例"
        :style="{ background: `url(${successCaseBgList[order]}) center center / cover no-repeat` }"
      >
        <SuccessCase :list="successCasesData" @prevChangeBg="prevChangeBg" @nextChangeBg="nextChangeBg"></SuccessCase>
      </SectionCard>
    </div>
    <!-- 关于e签宝 -->
    <div class="e-qianbao">
      <SectionCard bgColor="#fbfcfd" :isPcFlag="true" title="关于e签宝">
        <div class="content">
          <div class="left">
            <img class="cover-picture" src="@/assets/images/landing-semsign/cover-picture.png" alt="" />
          </div>
          <div class="right">
            <div class="line"></div>
            <div class="text">
              <div class="text-item" v-for="item in eQianBao" :key="item.key">
                {{ item.text }}
              </div>
            </div>
          </div>
        </div>
      </SectionCard>
    </div>
    <!-- 底部备案信息 -->
    <FooterBasis />
    <!-- 左侧计算机小象 -->
    <LeftBar />
    <!-- 免费试用申请弹框 -->
    <UseDialog ref="dialog" :wlCode="true" />
    <!-- 提示信息 -->
    <Message :type="message.type" :title="message.title" :content="message.content" :show.sync="message.show" />
    <!-- 提交完成弹框 -->
    <WeilingSuccessDialog :wlCode="true" v-if="showSuccessDialog" @closeform="showSuccessDialog = false" />
  </div>
</template>

<script>
import dataList from './dataList'
import qiyuMixin from '@/mixins/form/qiyu.js'
export default {
  name: 'semLocal',
  mixins: [qiyuMixin],
  components: {
    BannerForm: () => import('@/components/BannerForm.vue'),
    SectionCard: () => import('@/components/basics/SectionCard.vue'),
    LeftBar: () => import('@/components/LeftBar/index.vue'),
    Message: () => import('@/views/extension/components/pc/Message.vue'),
    WeilingSuccessDialog: () => import('@/components/saasApiSuccessForm.vue'),
    FooterBasis: () => import('@/components/FooterBasis.vue'),
    UseDialog: () => import('@/components/UseDialog.vue'),
    // Contact: () => import('@/components/Contact.vue'),
    SuccessCase: () => import('./components/successCase.vue'),
  },
  data() {
    return {
      m: 0,
      n: 0,
      order: 0,
      planSwiper: '',
      timer: null,
      changeWudian: 0,
      userClickWudian: false,
      logoSrc: require('@/assets/images/real-estate/logo.png'),
      pcBgImg: require('@/assets/images/sem-local/banner-bg.png'),
      flowPathBg: require('@/assets/images/sem-saas/flow-path.png'),
      wuDianBg: require('@/assets/images/sem-local/wudian-bg.png'),
      newModeBg: require('@/assets/images/landing-signet/yycj_bg.jpg'),
      qrCodeImg: require('@/assets/images/sem-local/deploy-process-qr-code.png'),
      // 落地页名字'e签宝宣传'，因为以上的组件会被多次复用，为了服务商收集数据的时候能够更准确，用这个名字去判断是否需要向服务商发送数据
      landingPageName: 'esignPropagate',
      showScrollForm: false,
      showSuccessDialog: false,
      message: {
        type: '',
        title: '',
        content: '',
        show: false,
      },
      bannerBottomData: dataList.bannerBottomData,
      difficultyData: dataList.difficultyData,
      deployProcessOneLine: dataList.deployProcessOneLine,
      deployProcessTwoLine: dataList.deployProcessTwoLine,
      hybridCloudData: dataList.hybridCloudData,
      wudianData: dataList.wudianData,
      solutionData: dataList.solutionData,
      newModeData: dataList.newModeData,
      successCasesData: dataList.successCasesData,
      successCaseBgList: dataList.successCaseBgList,
      eQianBao: dataList.eQianBao,
    }
  },
  mounted() {
    window.addEventListener('scroll', this.scrollHandle, true)
    this.autoSwitchWudian()
  },
  methods: {
    OnlineConsultationClick() {
      // this.handleCustomerClick({ templateId: '6651711' })
      this.handleNewBaiduService()
    },
    scrollHandle() {
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 滚动条偏移量
      this.showScrollForm = scrollTop >= 2280
    },
    showDialog() {
      this.$refs.dialog.showDialog()
    },
    setShowSuccessDialog(v) {
      this.showSuccessDialog = v
    },
    handleShowMsg({ type, title, content }) {
      this.message.type = type
      this.message.title = title
      this.message.content = content
      this.message.show = true
    },
    prevChangeBg() {
      // 切换背景图
      if (this.order <= 0) {
        this.order = 4
      } else {
        this.order--
      }
    },
    nextChangeBg() {
      // 切换背景图
      this.order++
      if (this.order > 4) {
        this.order = 0
      }
    },
    wudian(index) {
      this.m = index
      this.userClickWudian = true
    },
    autoSwitchWudian() {
      // 为了让用户知道【物电一体统一管理】能点击，做了个3s的自动切换tab，当用户点击后就直接清掉
      this.timer = setInterval(() => {
        if (this.userClickWudian) {
          this.beforeDestroy()
        }
        if (this.changeWudian === 0) {
          this.changeWudian = 1
        } else {
          this.changeWudian = 0
        }
        this.m = this.changeWudian
      }, 3000)
    },
  },
  beforeDestroy() {
    this.timer && clearInterval(this.timer)
    this.timer = null
  },
}
</script>

<style lang="less" scoped>
@import './style.less';
</style>
